import { render, staticRenderFns } from "./CustomerAddressSelect.vue?vue&type=template&id=452b3208&"
import script from "./CustomerAddressSelect.vue?vue&type=script&lang=js&"
export * from "./CustomerAddressSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CustomerAddressSelect.vue"
export default component.exports